module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "donation-area"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row clearfix d-flex align-items-start"
  }, [(_vm.$route.params.status == 'success') ? _c('div', {
    staticClass: "col-sm-6 col-md-8"
  }, [_vm._v("\n              Congratulations! your payment for donation of Rs. " + _vm._s(_vm.$route.params.amount) + " is successful.\n                      Transaction Number - " + _vm._s(_vm.$route.params.transactionId) + "\n          ")]) : _c('div', {
    staticClass: "col-sm-6 col-md-8"
  }, [_vm._v("\n              Sorry! Your transaction could not be completed.\n          ")])])])]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/logo.png"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://nirman.mkcl.org/"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://nirman.mkcl.org/people/net"
    }
  }, [_vm._v("Contact")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donation-title-area d-flex align-items-center"
  }, [_c('img', {
    staticClass: "img-leaf",
    attrs: {
      "src": "static/assets/images/petals.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Support the power of the youth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n         Copyright 2021 "), _c('span', [_vm._v("NIRMAN")]), _vm._v(" All rights reserved. "), _c('a', {
    attrs: {
      "href": "https://nirman.mkcl.org/"
    }
  }, [_vm._v("Privacy Policy")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b13d0442","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactUs/paymentStatus.vue
// module id = 69
// module chunks = 1